export enum CarStockOriginEnum {
  Own = 1,
  Sublease = 2,
  SubAcquisition = 3
}